import { RefObject, useEffect, useState } from 'react';

/**
 * ページ内の特定の要素をウィンドウのリサイズに合わせてscaleさせるhooks
 * @param ref 可変要素のDivのRef
 * @param width 可変要素の元の幅
 * @returns
 */
export const useWidthScale = (ref: RefObject<HTMLDivElement>, width: number) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function handleResize() {
      const scale = (ref.current?.clientWidth ?? width) / width;

      setScale(scale);
    }

    // 初回ロード時のサイズに基づいてスケーリング
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { scale };
};
